<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-07-11 17:02:40
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-07-21 15:46:41
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/ES/ESapply/component/orderInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--发票邮寄详情  -->
<template>
  <div>
    <el-row>
      <el-col :span="12">
        <span class="e-descriptions-item-label">发票邮寄地址:</span>
        <span class="e-descriptions-item-content">{{
          currentInvoiceAddress.province +
            currentInvoiceAddress.city +
            currentInvoiceAddress.county
        }}</span>
      </el-col>
      <el-col :span="12">
        <span class="e-descriptions-item-label">详情地址:</span>
        <span class="e-descriptions-item-content">{{
          currentInvoiceAddress.address
        }}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <span class="e-descriptions-item-label">收件人:</span>
        <span class="e-descriptions-item-content">{{
          currentInvoiceAddress.realName
        }}</span>
      </el-col>
      <el-col :span="12">
        <span class="e-descriptions-item-label">收件人联系方式:</span>
        <span class="e-descriptions-item-content">{{
          currentInvoiceAddress.mobile
        }}</span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import api from '../../../../api/evaluation/index';

export default {
  props: {
    applyId: {
      type: [Number, String],
    },
  },
  data() {
    return {
      currentInvoiceAddress: {},
    };
  },

  components: {},

  computed: {},

  created() {
    this.getInvoiceAddressList(this.applyId);
  },
  methods: {
    // 获取发票邮寄地址list
    async getInvoiceAddressList(applyId) {
      let res = await api.queryInvoiceAddressByApplyId({ applyId });
      if (res.code === '200') {
        let invoiceAddressList = res.data;
        this.currentInvoiceAddress =
          invoiceAddressList.length > 0 ? invoiceAddressList[0] : {};
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.e-descriptions-item-label,
.e-descriptions-item-content {
  font-size: 14px;
  color: #333;
  line-height: 1;
  &.color-red {
    color: #e50113;
  }
}
.e-descriptions-item-label {
  display: inline-block;
  width: 110px;
  text-align: right;
  margin-right: 10px;
  flex-shrink: 0;
}
.el-row {
  line-height: 1;
}
.el-row:not(:last-child) {
  margin-bottom: 20px;
}
.el-col {
  display: flex;
}
</style>
